import * as types from '../types.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: left; }
			.view td:nth-child(18)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Cliente</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
					<th data-index="14" data-visible="${this.visible[11]}">Prazo Entrega</th>
					<th data-index="15" data-visible="${this.visible[12]}">Condição Pagto</th>
					<th data-index="16" data-visible="${this.visible[13]}">Pagamento</th>
					<th data-index="17" data-visible="${this.visible[14]}">Lista Preços</th>
					<th data-index="18" data-visible="${this.visible[15]}">Rota</th>
					<th data-index="21" data-visible="${this.visible[16]}">Consumidor</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option(types.opt_person_type(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format(types.cpf(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format(types.cnpj(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format(types.ie(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option(types.opt_ie_type(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format(types.phone(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format(types.email(), record.email)}</td>
					<td data-visible='${this.visible[11]}'>${this.format(types.number(0), record.delivery_term)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('payment_terms', [record.payment_term_id]) ?? ''}</td>
					<td data-visible='${this.visible[13]}'>${this.option(types.opt_payment_method(), record.payment_method) || ''}</td>
					<td data-visible='${this.visible[14]}'>${await this.key('price_lists', [record.price_list_id]) ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${record.route_id ? `${record.route_code || ''}${record.route_name ? ` — ${record.route_name}` : ''}`.trim() : ''}</td>
					<td data-visible='${this.visible[16]}'>${this.option(types.opt_bool(), record.is_end_consumer)}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

